import React, { useRef, useState, useEffect } from "react";
import { Card } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";

// Görseller
import sozlesmeVeBorclar from "../../assets/eksiogluPictures/hizmetler/sozlesmeVeBorclar.webp";
import isHukuku from "../../assets/eksiogluPictures/hizmetler/isHukuku.webp";
import aileHukuku from "../../assets/eksiogluPictures/hizmetler/aileHukuku.webp";
import mirasHukuku from "../../assets/eksiogluPictures/hizmetler/mirasHukuku.webp";
import gayrimenkulHukuku from "../../assets/eksiogluPictures/hizmetler/gayrimenkulHukuku.webp";
import idareHukuku from "../../assets/eksiogluPictures/hizmetler/idareHukuku.webp";
import cezaHukuku from "../../assets/eksiogluPictures/hizmetler/cezaHukuku.webp";
import denizTicaretiHukuku from "../../assets/eksiogluPictures/hizmetler/denizTicaretiHukuku.webp";
import fikriMulkiyetHukuku from "../../assets/eksiogluPictures/hizmetler/fikriMulkiyetHukuku.webp";
import gumrukHukuku from "../../assets/eksiogluPictures/hizmetler/gumrukHukuku.webp";
import kisiselVerilerinKorunmasıHukuku from "../../assets/eksiogluPictures/hizmetler/kisiselVerilerinKorunmasiHukuku.webp";
import rekabetHukuku from "../../assets/eksiogluPictures/hizmetler/rekabetHukuku.webp";
import saglikHukuku from "../../assets/eksiogluPictures/hizmetler/saglikHukuku.webp";
import sigortaTahkimHukuku from "../../assets/eksiogluPictures/hizmetler/sigortaTahkimHukuku.webp";
import ticaretHukuku from "../../assets/eksiogluPictures/hizmetler/ticaretHukuku.webp";
import tuketiciHukuku from "../../assets/eksiogluPictures/hizmetler/tuketiciHukuku.webp";
import vatandaslikHukuku from "../../assets/eksiogluPictures/hizmetler/vatandaslikHukuku.webp";
import vergiHukuku from "../../assets/eksiogluPictures/hizmetler/vergiHukuku.webp";
import bilisimHukuku from "../../assets/eksiogluPictures/hizmetler/bilisimHukuku.webp";
import sporHukuku from "../../assets/eksiogluPictures/hizmetler/sporHukuku.webp";
import icraHukuku from "../../assets/eksiogluPictures/hizmetler/icraHukuku.webp";
import icraHukuku2 from "../../assets/eksiogluPictures/hizmetler/icraHukuku2.png";

// Swiper (mobil için)
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { MdOutlineArrowOutward, MdOutlineArrowRightAlt } from "react-icons/md";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import "../../assets/css/DynamicCardSection.css";

const DynamicCardSection = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const cardData = [
    {
      title: "Sözleşmeler ve Borçlar Hukuku",
      imageSrc: sozlesmeVeBorclar,
      link: "/ozel-hukuk/sozlesmeler-ve-borclar-hukuku",
    },
    {
      title: "Aile Hukuku",
      imageSrc: aileHukuku,
      link: "/ozel-hukuk/aile-hukuku",
    },
    {
      title: "İş ve Sosyal Güvenlik Hukuku",
      imageSrc: isHukuku,
      link: "/sosyal-ve-idari-hukuk/is-ve-sosyal-guvenlik-hukuku",
    },
    {
      title: "Ceza Hukuku",
      imageSrc: cezaHukuku,
      link: "/kamu-hukuku/ceza-hukuku",
    },
    {
      title: "İcra İflas Hukuku",
      imageSrc: icraHukuku2,
      link: "/ekonomi-ve-ticaret-hukuku/icra-iflas-hukuku",
    },
    {
      title: "Miras Hukuku",
      imageSrc: mirasHukuku,
      link: "/ozel-hukuk/miras-hukuku",
    },
    {
      title: "Gayrimenkul Hukuku",
      imageSrc: gayrimenkulHukuku,
      link: "/ozel-hukuk/gayrimenkul-hukuku",
    },
    {
      title: "İdare Hukuku",
      imageSrc: idareHukuku,
      link: "/kamu-hukuku/idare-hukuku",
    },
    {
      title: "Vergi Hukuku",
      imageSrc: vergiHukuku,
      link: "/kamu-hukuku/vergi-hukuku",
    },
    {
      title: "Gümrük Hukuku",
      imageSrc: gumrukHukuku,
      link: "/kamu-hukuku/gumruk-hukuku",
    },
    {
      title: "Vatandaşlık Hukuku",
      imageSrc: vatandaslikHukuku,
      link: "/kamu-hukuku/vatandaslik-hukuku",
    },
    {
      title: "Ticaret Hukuku",
      imageSrc: ticaretHukuku,
      link: "/ozel-hukuk/ticaret-hukuku",
    },
    {
      title: "Deniz Ticareti Hukuku",
      imageSrc: denizTicaretiHukuku,
      link: "/ekonomi-ve-ticaret-hukuku/deniz-ticareti-hukuku",
    },
    {
      title: "Rekabet Hukuku",
      imageSrc: rekabetHukuku,
      link: "/ekonomi-ve-ticaret-hukuku/rekabet-hukuku",
    },
    {
      title: "Fikri ve Sınai Mülkiyet Hukuku",
      imageSrc: fikriMulkiyetHukuku,
      link: "/ekonomi-ve-ticaret-hukuku/fikri-mulkiyet-hukuku",
    },
    {
      title: "Tüketici Hukuku",
      imageSrc: tuketiciHukuku,
      link: "/sosyal-ve-idari-hukuk/tuketici-hukuku",
    },
    {
      title: "Sağlık Hukuku",
      imageSrc: saglikHukuku,
      link: "/sosyal-ve-idari-hukuk/saglik-hukuku",
    },
    {
      title: "Spor Hukuku",
      imageSrc: sporHukuku,
      link: "/sosyal-ve-idari-hukuk/spor-hukuku",
    },
    {
      title: "Sigorta (Tahkim) Hukuku",
      imageSrc: sigortaTahkimHukuku,
      link: "/sigorta-tahkim-hukuku",
    },
    {
      title: "Bilişim Hukuku",
      imageSrc: bilisimHukuku,
      link: "/teknoloji-ve-internet-hukuku/bilisim-hukuku",
    },
    {
      title: "Kişisel Verilerin Korunması Hukuku",
      imageSrc: kisiselVerilerinKorunmasıHukuku,
      link: "/teknoloji-ve-internet-hukuku/kisisel-verilerin-korunmasi-hukuku",
    },
  ];

  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const [expanded, setExpanded] = useState(false);

  // Smooth max-height animasyonu için ölçümler
  const wrapRef = useRef(null);
  const gridRef = useRef(null);
  const headingRef = useRef(null);
  const [maxH, setMaxH] = useState("0px");

  // Yükseklik ölç
  useEffect(() => {
    const measure = () => {
      if (!wrapRef.current || !gridRef.current) return;
      if (expanded) {
        // Tümü görünür
        setMaxH(`${gridRef.current.scrollHeight}px`);
      } else {
        // Sadece ilk satır (3 kart)
        const firstCard = gridRef.current.querySelector(".law-card");
        const styles = getComputedStyle(gridRef.current);
        const padTop = parseFloat(styles.paddingTop) || 0;
        const padBottom = parseFloat(styles.paddingBottom) || 0;
        const rowH = firstCard
          ? firstCard.offsetHeight + padTop + padBottom
          : 380;
        setMaxH(`${Math.ceil(rowH)}px`);
      }
    };
    measure();
    const t = setTimeout(measure, 50);
    window.addEventListener("resize", measure);
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", measure);
    };
  }, [expanded, isMobile, cardData.length]);

  const handleShowAll = () => {
    if (!gridRef.current) return;
    setMaxH(`${gridRef.current.scrollHeight}px`);
    setExpanded(true);
  };

  const handleShowLess = () => {
    if (headingRef.current) {
      headingRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setExpanded(false);
  };

  return (
    <>
      <h2
        ref={headingRef}
        className="font-bold text-[35px] text-center pt-[20px] font-sans"
        style={{
          background: "linear-gradient(135deg, #0F172A, #333333)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        ÇALIŞMA ALANLARIMIZ
      </h2>

      {isMobile ? (
        <div className="mini-swiper mt-5 px-3">
          <Swiper
            navigation
            pagination={{ clickable: true }}
            spaceBetween={0}
            slidesPerView={1}
            loop={true}
            centeredSlides={false}
            speed={600}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Navigation, Pagination, Autoplay]}
          >
            {cardData.map((card, index) => (
              <SwiperSlide key={index}>
                <Card className="text-center card-plain mb-3">
                  <div
                    className="card-image"
                    onClick={() => navigate(card.link)}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      alt={card.title}
                      title={card.title}
                      className="img rounded img-hover"
                      src={card.imageSrc}
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "auto",
                        aspectRatio: "1 / 1",
                        display: "block",
                      }}
                    />
                  </div>
                  <div className="card-body font-sans">
                    <h3>{card.title}</h3>
                  </div>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <>
          <div
            ref={wrapRef}
            className={`law-grid-wrap ${expanded ? "expanded" : "collapsed"}`}
            style={{ maxHeight: maxH }}
          >
            <div ref={gridRef} className="law-grid">
              {cardData.map((c, i) => (
                <article
                  key={i}
                  className={`law-card font-sans ${
                    !expanded && i >= 3 ? "hidden-in-collapsed" : ""
                  }`}
                >
                  <div
                    className="card-bg"
                    style={{ backgroundImage: `url(${c.imageSrc})` }}
                    aria-hidden="true"
                  />

                  <button
                    className="card-action"
                    aria-label="Devamını oku"
                    onClick={() => (window.location.href = `${c.link}`)}
                  >
                    <span className="icon-center">
                      <MdOutlineArrowOutward />
                    </span>
                    <span className="label-row">
                      <span className="label-text">Devamını oku</span>
                      <MdOutlineArrowRightAlt className="label-arrow" />
                    </span>
                  </button>

                  <div className="card-content">
                    <div className="card-tag" aria-hidden="true"></div>
                    <h3 className="card-title ">{c.title}</h3>
                  </div>
                </article>
              ))}
            </div>
            {!expanded && <div className="law-grid-fade" />}
          </div>

          <div className="law-grid-actions">
            {!expanded ? (
              <button className="law-btn" onClick={handleShowAll}>
                Hepsini Gör
              </button>
            ) : (
              <button className="law-btn outline" onClick={handleShowLess}>
                Daha Az Göster
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default DynamicCardSection;
